import { Component } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    // Log to backend
    try {
      const userEmail = localStorage.getItem("user_email") || "";
      axios.post(`${API}/log/error`, {
        type: "react_crash",
        message: error?.message || String(error),
        stack: error?.stack || "",
        url: window.location.href,
        user_email: userEmail,
        component: info?.componentStack?.substring(0, 500) || "",
        action: "page_render",
      }).catch(() => {});
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="error-boundary">
          <div className="max-w-lg w-full">
            <div className="text-center mb-6">
              <div className="inline-block bg-[#FF3B30] text-white px-4 py-1.5 font-bold text-lg mb-4">
                ERREUR TEMPORAIRE
              </div>
              <p className="text-white/80 text-sm mb-2">
                Un probleme est survenu lors du chargement de cette page.
              </p>
              <p className="text-white/50 text-xs mb-6">
                Ne vous inquietez pas, votre compte et vos donnees sont intacts.
              </p>
            </div>

            <div className="bg-[#111] border border-[#333] p-5 mb-6">
              <p className="text-[#00E676] font-bold text-sm mb-3 uppercase tracking-wider">
                Solutions recommandees
              </p>
              <p className="text-white/70 text-sm mb-4">
                Effectuez les actions suivantes sur PC, Mac ou smartphone :
              </p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <span className="bg-[#00E676] text-[#0A0A0A] w-6 h-6 flex items-center justify-center font-bold text-xs flex-shrink-0">1</span>
                  <p className="text-white/80 text-sm">Nettoyez les caches et cookies de votre navigateur</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="bg-[#00E676] text-[#0A0A0A] w-6 h-6 flex items-center justify-center font-bold text-xs flex-shrink-0">2</span>
                  <p className="text-white/80 text-sm">Essayez le mode Navigation privee</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="bg-[#00E676] text-[#0A0A0A] w-6 h-6 flex items-center justify-center font-bold text-xs flex-shrink-0">3</span>
                  <p className="text-white/80 text-sm">Essayez avec Google Chrome et/ou Firefox</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                className="neo-button-primary flex-1 py-3 text-sm font-bold"
              >
                Actualiser la page
              </button>
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.href = "/";
                }}
                className="neo-button-secondary flex-1 py-3 text-sm font-bold"
              >
                Retour a l'accueil
              </button>
            </div>

            <p className="text-center text-white/30 text-xs mt-6">
              Si le probleme persiste, contactez le support : contact@profimy.app
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
